export const load = () => ({
	title: 'Hotel Noise Reduction: Stop Guest Complaints & Refunds',
	h1: 'A Non-Invasive Approach to Resolving Chronic Hotel Noise Issues',
	description:
		'Solve chronic hotel noise issues without window replacement. Indow inserts reduce noise by up to 70%, protecting reputations and revenue with zero downtime.',
	showTitle: true,
});
